const initialState = {
    list: { data: [], total: 0 },
    error: '',
};

export default function pickup(state = initialState, action) {
    switch (action.type) {
        default:
            return state;
    }
}
